"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Box_1 = require("@mui/material/Box");
var Button_1 = require("@mui/material/Button");
var Typography_1 = require("@mui/material/Typography");
var Modal_1 = require("@mui/material/Modal");
var react_1 = require("react");
var Stack_1 = require("@mui/material/Stack");
var style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};
var GenericModal = react_1.forwardRef(function (props, ref) {
    var _a = React.useState(false), open = _a[0], setOpen = _a[1];
    var _b = React.useState(false), isMobile = _b[0], setIsMobile = _b[1];
    //choose the screen size 
    var handleResize = function () {
        if (window.innerWidth < 720) {
            setIsMobile(true);
        }
        else {
            setIsMobile(false);
        }
    };
    var handleOpen = function () {
        setOpen(true);
        window.addEventListener("resize", handleResize);
        handleResize();
    };
    var handleClose = function () { return setOpen(false); };
    react_1.useImperativeHandle(ref, function () { return ({
        handleOpen: handleOpen
    }); });
    return (React.createElement(Modal_1.default, { open: open, onClose: handleClose, "aria-labelledby": "parent-modal-title", "aria-describedby": "parent-modal-description" },
        React.createElement(Box_1.default, { sx: __assign(__assign({}, style), { width: isMobile ? '90%' : '50%', overflowY: 'auto', maxHeight: '85%' }) },
            React.createElement(Typography_1.default, null, props.text),
            React.createElement(Stack_1.default, { spacing: 2, direction: "row", justifyContent: "flex-end" },
                React.createElement(Button_1.default, { variant: "outlined", onClick: function () {
                        handleClose();
                    } }, "Cancel"),
                React.createElement(Button_1.default, { variant: "contained", onClick: function () {
                        props.action(props.value);
                        handleClose();
                    } }, "Confirm")))));
});
exports.default = GenericModal;
//# sourceMappingURL=GenericModal.js.map